// tslint:disable-next-line: no-submodule-imports
import withStyles from 'isomorphic-style-loader/withStyles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UAParser } from 'ua-parser-js';
import * as PlaybackActions from '../actions/Playback';
import { getInstance } from '../player';
import { PlaybackErrors } from '../types/playback/PlaybackErrorsEnum';
import { globals } from '../utils';
import { dispatchPlaybackMethods } from '../utils/dispatchPlaybackMethods';
import ContextMenuButton from './ContextMenuButton';
import ProgressBar from './ProgressBar';
import * as Styles from './Transport.scss';
import NextButton from './transport/NextButton';
import PlayButton from './transport/PlayButton';
import PreviousButton from './transport/PreviousButton';
import RepeatButton from './transport/RepeatButton';
import ShuffleButton from './transport/ShuffleButton';
import ThumbButton from './transport/ThumbButton';
import VolumeButton from './transport/VolumeButton';
import Button from './widgets/items/Button';
import TransportOverlay from './TransportOverlay';
import TransportOverlayButton from './transport/TransportOverlayButton';
import { TRANSPORT_OVERLAY_PLAY_QUEUE, TRANSPORT_OVERLAY_ACTIVE_QUEUES, } from '../actions/TransportOverlay';
import { isDesktop } from '../utils/platform';
const ua = new UAParser(navigator.userAgent);
const os = ua.getOS();
const browser = ua.getBrowser();
function convertToTimestamp(time) {
    const timestamp = new Date(time * 1000);
    // There's no hours, so only show MM:SS
    if (timestamp.getUTCHours() === 0) {
        // If no tens digit minutes, just display the singles digit, so M:SS.
        if (timestamp.getMinutes() >= 0 && timestamp.getMinutes() <= 9) {
            return timestamp.toISOString().substring(15, 19);
        }
        return timestamp.toISOString().substring(14, 19);
    }
    // There's hours, so show HH::MM:SS
    return timestamp.toISOString().substr(11, 8);
}
const Timestamps = ({ time, duration, displayAbove }) => (React.createElement("div", { className: [Styles.timestamps, displayAbove ? Styles.above : ''].join(' ') },
    React.createElement("span", null, convertToTimestamp(time)),
    duration ? React.createElement("span", null,
        " - ",
        convertToTimestamp(Math.max(duration - time, 0))) : null));
class Transport extends Component {
    constructor(props) {
        super(props);
        this.handleMouseOver = () => {
            this.setState({ hovering: true });
        };
        this.handleMouseLeave = () => {
            this.setState({ hovering: false });
        };
        this.handleMouseEnter = (e) => {
            var _a, _b;
            if (!((_b = (_a = this.props.controls) === null || _a === void 0 ? void 0 : _a.visualPlayQueue) === null || _b === void 0 ? void 0 : _b.isDisabled) &&
                !this.props.media.playQueue &&
                !this.props.media.fetchingPlayQueue) {
                this.onSelected(e, this.props.media.onVisualPlayQueueDataRequired);
                this.props.dispatch({ type: PlaybackActions.AWAIT_PLAY_QUEUE });
            }
        };
        this.onSelected = (e, methods = []) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            (_d = (_b = (_a = e) === null || _a === void 0 ? void 0 : _a.detail) === null || _b === void 0 ? void 0 : (_c = _b).preventDefault) === null || _d === void 0 ? void 0 : _d.call(_c);
            (_j = (_g = (_f = (_e = e) === null || _e === void 0 ? void 0 : _e.detail) === null || _f === void 0 ? void 0 : _f.detail) === null || _g === void 0 ? void 0 : (_h = _g).preventDefault) === null || _j === void 0 ? void 0 : _j.call(_h);
            dispatchPlaybackMethods(this.props.dispatch, this.props.media.mediaId, methods);
        };
        this.handleSelected = (methods = []) => {
            this.onSelected(null, methods);
        };
        this.onPrimarySelected = (e) => {
            var _a;
            this.onSelected(e, (_a = this.props.media.miniTitleLink) === null || _a === void 0 ? void 0 : _a.onItemSelected);
        };
        this.onSecondaryArtistSelected = (e) => {
            var _a, _b;
            this.onSelected(e, (_b = (_a = this.props.media) === null || _a === void 0 ? void 0 : _a.miniSubTitleArtistLink) === null || _b === void 0 ? void 0 : _b.onItemSelected);
        };
        this.onSecondaryContainerSelected = (e) => {
            var _a, _b;
            this.onSelected(e, (_b = (_a = this.props.media) === null || _a === void 0 ? void 0 : _a.miniSubTitleContainerLink) === null || _b === void 0 ? void 0 : _b.onItemSelected);
        };
        this.onSecondarySelected = (e) => {
            var _a;
            this.onSelected(e, (_a = this.props.media.miniSubTitleLink) === null || _a === void 0 ? void 0 : _a.onItemSelected);
        };
        this.onArtworkSelected = (e) => {
            var _a;
            this.onSelected(e, (_a = this.props.media.miniArtworkLink) === null || _a === void 0 ? void 0 : _a.onItemSelected);
        };
        this.onBadgeClicked = (e) => {
            switch (e.detail) {
                case 'LYRICS':
                    this.onArtworkSelected(e);
                default:
                    return;
            }
        };
        this.onTimeupdate = (time) => {
            const { currentTime, scrubbing } = this.state;
            const bufferTime = this.player.getBufferedTime();
            if (!scrubbing) {
                // Only update current time when playback stream has moved a whole second forward
                const roundedTime = Math.floor(time);
                if (roundedTime === currentTime) {
                    return;
                }
                this.setState({
                    bufferTime,
                    currentTime: roundedTime,
                    seekingTime: undefined,
                });
            }
        };
        this.onSeekUpdate = (time) => {
            const roundedTime = Math.round(time);
            this.setState({
                seekingTime: roundedTime,
                currentTime: roundedTime,
            });
        };
        this.onScrubberDragStart = () => {
            this.setState({
                scrubbing: true,
            });
        };
        this.onScrubberDragEnd = () => {
            this.setState({
                scrubbing: false,
            });
        };
        this.onBuffertime = (time) => {
            this.setState({ bufferTime: Math.round(time) });
        };
        this.onStarted = () => {
            this.setState({
                bufferTime: 0,
                currentTime: 0,
                playbackStarted: true,
            });
            this.props.dispatch({ type: PlaybackActions.STARTED });
        };
        this.onEnded = () => {
            this.setState({
                bufferTime: 0,
                currentTime: 0,
                playbackStarted: false,
            });
            this.props.dispatch({ type: PlaybackActions.ENDED });
        };
        this.onError = (error) => {
            if (error === PlaybackErrors.PLAY_NOT_AUTHORIZED) {
                this.props.dispatch({ type: PlaybackActions.PAUSED });
                if (browser.name === 'Safari') {
                    // dispatch error for Safari-specific error dialog
                    this.props.dispatch({ type: PlaybackActions.ERROR, payload: { error } });
                }
            }
            else {
                this.props.dispatch({ type: PlaybackActions.ERROR, payload: { error } });
            }
        };
        this.onStalled = (isStalled) => {
            if (!isStalled) {
                // Rebuffer ended
                this.props.dispatch({ type: PlaybackActions.REBUFFERED });
            }
        };
        this.state = {
            currentTime: 0,
            bufferTime: 0,
            seekingTime: undefined,
            playerInitialized: false,
            playbackStarted: false,
            duration: 0,
            hovering: false,
            scrubbing: false,
        };
    }
    async componentDidMount() {
        const { media } = this.props;
        const { mediaId, onMiniTransportViewed } = media;
        this.setState({ mediaId });
        dispatchPlaybackMethods(this.props.dispatch, mediaId, onMiniTransportViewed);
    }
    async componentDidUpdate() {
        var _a, _b;
        const { media, overlayTemplates } = this.props;
        const { mediaId, onMiniTransportViewed } = media;
        const hasOverlay = overlayTemplates.length > 0;
        if (media && mediaId) {
            if (!this.state.playerInitialized) {
                this.setState({ playerInitialized: true });
                this.player = await getInstance();
                this.player.addEventListener('timeupdate', this.onTimeupdate);
                this.player.addEventListener('buffertime', this.onBuffertime);
                this.player.addEventListener('started', this.onStarted);
                this.player.addEventListener('ended', this.onEnded);
                this.player.addEventListener('error', this.onError);
                this.player.addEventListener('stalled', this.onStalled);
            }
            const isLiveStream = ((_a = media) === null || _a === void 0 ? void 0 : _a.durationSeconds) === -1;
            const duration = !isLiveStream
                ? ((_b = this.player) === null || _b === void 0 ? void 0 : _b.getDuration()) || media.durationSeconds
                : null;
            if (duration !== this.state.duration && duration > 0) {
                this.setState({ duration });
            }
        }
        if (mediaId !== this.state.mediaId && !hasOverlay) {
            dispatchPlaybackMethods(this.props.dispatch, mediaId, onMiniTransportViewed);
            this.setState({ mediaId });
        }
    }
    async componentWillUnmount() {
        var _a, _b, _c, _d, _e, _f;
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.removeEventListener('timeupdate', this.debouncedTimeUpdate);
        (_b = this.player) === null || _b === void 0 ? void 0 : _b.removeEventListener('buffertime', this.onBuffertime);
        (_c = this.player) === null || _c === void 0 ? void 0 : _c.removeEventListener('started', this.onStarted);
        (_d = this.player) === null || _d === void 0 ? void 0 : _d.removeEventListener('ended', this.onEnded);
        (_e = this.player) === null || _e === void 0 ? void 0 : _e.removeEventListener('error', this.onError);
        (_f = this.player) === null || _f === void 0 ? void 0 : _f.removeEventListener('stalled', this.onStalled);
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const media = this.props.media;
        const { isNowPlaying, isTransportOverlayOpen } = this.props;
        const buttonSize = isNowPlaying ? 'medium' : 'small';
        const hasOverlay = (this.props.overlayTemplates.length > 0 && !this.props.isNowPlaying) ||
            this.props.isDialogShowing;
        const emptyClass = media.mediaId ? null : Styles.empty;
        const nowPlayingClass = isNowPlaying ? Styles.nowPlayingView : null;
        const transportOverlayOpen = isTransportOverlayOpen ? Styles.transportOverlayOpen : '';
        const overlayClass = hasOverlay ? Styles.overlay : null;
        const safariClass = browser.name === 'Safari' ? Styles.safari : null;
        const splitSubtitle = ((_a = media.subTitle) === null || _a === void 0 ? void 0 : _a.indexOf('-')) !== -1 ? (_b = media.subTitle) === null || _b === void 0 ? void 0 : _b.split('-')[1].trim() : '';
        const containerClassName = [
            media.mediaId && Styles.background,
            safariClass,
            emptyClass,
            nowPlayingClass,
            transportOverlayOpen,
            overlayClass,
        ].join(' ');
        return (React.createElement("div", { className: containerClassName, onMouseOver: this.handleMouseOver, onMouseLeave: this.handleMouseLeave },
            React.createElement("div", { className: Styles.baseline }),
            React.createElement("div", { className: Styles.transport, id: "transport" },
                React.createElement("div", { className: [Styles.trackButtons, 'box'].join(' ') },
                    React.createElement("music-horizontal-item", { "icon-name": "maximize", "button-variant": "primary", class: [this.state.hovering ? 'hovered' : '', 'hydrated'].join(' '), "show-action-button": "true", "enable-badge-click": "true", "image-src": media.artwork, "primary-text": media.title, "secondary-text": media.artistName, "primary-href": (_c = media.miniTitleLink) === null || _c === void 0 ? void 0 : _c.deeplink, "secondary-href": (_d = media.miniSubTitleArtistLink) === null || _d === void 0 ? void 0 : _d.deeplink, "bottom-tags": media.hasLyrics ? 'LYRICS' : null, onmusicPrimaryTextActivate: this.onPrimarySelected, onmusicSecondaryTextActivate: this.onSecondaryArtistSelected, onmusicActionButtonActivate: this.onArtworkSelected, "secondary-text-2": media.subTitleContainerType
                            ? media.subTitleContainerType
                            : splitSubtitle, "secondary-href-2": media.subTitleContainerType
                            ? (_e = media.miniSubTitleContainerLink) === null || _e === void 0 ? void 0 : _e.deeplink : null, onmusicSecondaryText2Activate: media.subTitleContainerType
                            ? this.onSecondaryContainerSelected
                            : null, onmusicBadgeActivate: this.onBadgeClicked }),
                    React.createElement("div", { className: [Styles.secondaryButtons, 'box'].join(' ') },
                        React.createElement("div", { className: Styles.addContainer }, ((_f = media) === null || _f === void 0 ? void 0 : _f.button) && (React.createElement(Button, { data: media.button, handleSelected: this.handleSelected, slot: "buttons", size: "small" }))),
                        React.createElement("div", { className: Styles.contextMenuContainer }, ((_g = media) === null || _g === void 0 ? void 0 : _g.contextMenu) && (React.createElement(ContextMenuButton, { options: media.contextMenu.options, disabled: media.contextMenu.disabled, variant: "primary", iconName: "more", size: "small" }))))),
                React.createElement("div", { className: [Styles.mainControls, 'box'].join(' ') },
                    React.createElement(ThumbButton, { size: buttonSize, icon: "dislike" }),
                    React.createElement(RepeatButton, { size: buttonSize }),
                    React.createElement(PreviousButton, { size: buttonSize }),
                    React.createElement(PlayButton, null),
                    React.createElement(NextButton, { size: buttonSize }),
                    React.createElement(ShuffleButton, { size: buttonSize }),
                    React.createElement(ThumbButton, { size: buttonSize, icon: "like" })),
                React.createElement("div", { onMouseEnter: this.handleMouseEnter, className: [Styles.secondaryControls, 'box'].join(' ') },
                    isDesktop(window) && (React.createElement("div", { className: Styles.volumeContainer },
                        React.createElement(VolumeButton, { size: buttonSize, isTransportOverlayOpen: isTransportOverlayOpen }))),
                    React.createElement("div", { className: Styles.playQueueContainer },
                        React.createElement(TransportOverlayButton, { id: TRANSPORT_OVERLAY_PLAY_QUEUE, visible: !!((_h = this.props.controls) === null || _h === void 0 ? void 0 : _h.visualPlayQueue), action: PlaybackActions.TRIGGER_PLAY_QUEUE, disabled: (_k = (_j = this.props.controls) === null || _j === void 0 ? void 0 : _j.visualPlayQueue) === null || _k === void 0 ? void 0 : _k.isDisabled, icon: "playqueue", size: buttonSize })),
                    React.createElement("div", null,
                        React.createElement(TransportOverlayButton, { id: TRANSPORT_OVERLAY_ACTIVE_QUEUES, visible: !!((_l = this.props.controls) === null || _l === void 0 ? void 0 : _l.activeQueues), action: PlaybackActions.TRIGGER_ACTIVE_QUEUES, icon: "speaker", size: buttonSize }))),
                React.createElement("div", { className: Styles.progressBar },
                    !hasOverlay && this.state.duration ? (React.createElement(ProgressBar, { time: this.state.currentTime, bufferTime: this.state.bufferTime, duration: this.state.duration, mediaId: media.mediaId, displayScrubber: !((_m = this.props.controls.scrub) === null || _m === void 0 ? void 0 : _m.isDisabled) &&
                            this.state.hovering &&
                            !isTransportOverlayOpen, scrubbing: this.state.scrubbing, onSeekUpdate: this.onSeekUpdate, onScrubberDragStart: this.onScrubberDragStart, onScrubberDragEnd: this.onScrubberDragEnd })) : null,
                    React.createElement(Timestamps, { time: this.state.seekingTime !== undefined
                            ? this.state.seekingTime
                            : this.state.currentTime, duration: this.state.duration, displayAbove: !this.props.isNowPlaying }))),
            !globals.amznMusic.ssr && React.createElement(TransportOverlay, null)));
    }
}
function mapStateToProps(state) {
    return {
        media: state.Media,
        actions: state.PlaybackActions,
        controls: state.PlaybackStates,
        playbackEvents: state.PlaybackEvents,
        overlayTemplates: state.TemplateStack.overlayTemplates,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withStyles(Styles)(connect(mapStateToProps, mapDispatchToProps)(Transport));
